/* eslint-disable max-params */
import React, { useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { MINOR_IMPERFECTION, PERFECT_CONDITION_DESCRIPTION, PERFECT_CONDITION_TEXTS } from "./constant";
import CheckIcon from "./images/green-check.svg";
import { NUMBER } from "../../../constants/app-constants";
import ArrowIcon from "../../shared/arrow";
import Perfect from "./perfect";

const SectionList = ({
    detailReport = [],
    activeTabKey = "",
    showingSearchSuggestions = false,
    noDefects
}) => {
    const [isOpen, setIsOpen] = useState({
        0: true
    });

    const onArrowClickHandler = (id) => {
        setIsOpen((state) => ({ [id]: !state[id] }));
    };

    const renderDefectsSubSection = (subSectionData = {}) => {
        const showDefectsSubSection = subSectionData && subSectionData.imagesList && subSectionData.imagesList.length;
        return (<React.Fragment>
            {showingSearchSuggestions && showDefectsSubSection && <strong styleName={"styles.headerTitle"}>Imperfections</strong>}
            {showDefectsSubSection && subSectionData.imagesList.map((subSection, subSectionIndex) => {
                const { iconUrl = "", imageUrl = "", subTitle, title} = subSection || {};
                return (<div key={subSectionIndex} styleName={"styles.cardWrap"}>
                    <div styleName={"styles.leftColumn"}>
                        <div styleName={"styles.flexOne"}>
                            <h5>{title}{subTitle ? `: ${subTitle}` : ""}</h5>
                        </div>
                        <div styleName={"styles.defectsImage"}>
                            <img
                                src={imageUrl}
                                alt="Defects" />
                        </div>
                    </div>
                    {!!iconUrl && <span styleName={"styles.faultDetailImage"}>
                        <img
                            src={iconUrl}
                            alt="fault" />
                    </span>}
                </div>);
            })}
        </React.Fragment>);
    };

    const renderDefectsSection = (data) => {
        return (<React.Fragment>
            {data.map((elem, index) => {
                return (elem.imagesList && elem.imagesList.length ? <React.Fragment key={index}>
                    <h4 styleName={"styles.heading"}>{elem.title}</h4>
                    {renderDefectsSubSection(elem)}
                </React.Fragment> : null);
            })}
        </React.Fragment>);
    };

    const renderPerfectPartsSubSection = (subSectionData) => {
        const showSubSectionData = subSectionData && subSectionData.subCategories && subSectionData.subCategories.length;
        return (
            <React.Fragment>

                {!!(showSubSectionData) && subSectionData.subCategories.map((subSection, subSectionIndex) => {
                    return (!subSection.isDefective &&
                <li key={subSectionIndex}>
                    <span>{subSection.title}</span>
                    <img src={CheckIcon} alt="Check" />
                </li>);
                })}
            </React.Fragment>);

    };

    const renderPerfectPartsSection = (data) => {
        const upArrow = NUMBER.ZERO;
        const downArrow = -NUMBER.ONE_HUNDRED_EIGHTY;
        return (<React.Fragment>
            {data.map((elem, index) => {
                return (<React.Fragment key={index}>
                    <div onClick={() => onArrowClickHandler(index)} styleName={"styles.accordionHeader"}>
                        <strong>{elem.title}</strong>
                        <ArrowIcon grey={"GreyArrow"} rotateBy={isOpen[index] ? upArrow : downArrow} />
                    </div>
                    {!!(isOpen[index]) &&
                    <React.Fragment>

                        <ul styleName={"styles.featureDetailsList"} >
                            {renderPerfectPartsSubSection(elem)}
                        </ul>
                    </React.Fragment>
                    }
                </React.Fragment>);
            })}
        </React.Fragment>);
    };

    const renderSectionListData = () => {
        if (noDefects && activeTabKey === MINOR_IMPERFECTION) {
            return (
                !showingSearchSuggestions ? <Perfect
                    heading={PERFECT_CONDITION_TEXTS[activeTabKey]}
                    text={PERFECT_CONDITION_DESCRIPTION[activeTabKey]}
                /> : <React.Fragment />);
        } else {
            switch (activeTabKey) {
            case MINOR_IMPERFECTION:
                return showingSearchSuggestions
                    ? renderDefectsSubSection(detailReport)
                    : renderDefectsSection(detailReport);
            default:
                return showingSearchSuggestions
                    ? <React.Fragment>
                        <strong styleName={"styles.headerTitle"}>{detailReport.title}</strong>
                        <ul className={"mb-3"} styleName={"styles.featureDetailsList"}>{renderPerfectPartsSubSection(detailReport)}</ul>
                    </React.Fragment>

                    : renderPerfectPartsSection(detailReport);
            }
        }
    };
    return (
        <React.Fragment>
            {renderSectionListData()}
        </React.Fragment>
    );
};

SectionList.propTypes = {
    detailReport: PropTypes.array,
    showingSearchSuggestions: PropTypes.bool,
    activeTabKey: PropTypes.string,
    noDefects: PropTypes.func
};
export default SectionList;
